import { Box, Button, HStack } from '@medely/ui-kit';
import React from 'react';

type PreBookConfirmationButtonsProps = {
  closeButtonClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  handleBookClick: () => void;
};

export const PreBookConfirmationButtons = ({
  closeButtonClick,
  disabled,
  loading,
  handleBookClick,
}: PreBookConfirmationButtonsProps) => {
  return (
    <HStack gap={2} width="100%">
      <Box flex={1}>
        <Button
          variant="outlined"
          fullWidth
          onClick={closeButtonClick}
          disabled={loading}
          testId="book-job-confirmation-dialog-close-button"
        >
          Close
        </Button>
      </Box>
      <Box flex={1}>
        <Button
          fullWidth
          disabled={loading || disabled}
          loading={loading}
          onClick={handleBookClick}
          testId="book-job-confirmation-dialog-book-button"
        >
          Book shift
        </Button>
      </Box>
    </HStack>
  );
};
